module.exports = __webpack_public_path__ + "static/img/twitter.73c31e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter.png
// module id = Ednz
// module chunks = 2